import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ReisekostenabrechnungStatiService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ReisekostenabrechnungStatiService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ReisekostenabrechnungStatiServiceModule {}
